export default __webpack_public_path__ + "afc41b5db5ac603d21455256795192bb.svg";